import { render } from "./navtopF10.vue?vue&type=template&id=b7faff16&scoped=true&ts=true"
import script from "./navtopF10.vue?vue&type=script&lang=ts"
export * from "./navtopF10.vue?vue&type=script&lang=ts"

import "./navtopF10.vue?vue&type=style&index=0&id=b7faff16&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7faff16"]])

export default __exports__